export class UOC {
  id: Number;
  name: String;

  constructor() {
    this.id = null;
    this.name = '';
  }
}
